"use client";

import React, { useEffect } from "react";
import {
  DynamicPage,
  FormIdentifier,
  PageWithLayout,
  useAuth,
} from "@shesha-io/reactjs";
import { useRouter } from "next/navigation";

interface IProps {
  searchParams: NodeJS.Dict<string | string[]>;
}

const Home: PageWithLayout<IProps> = (props) => {
  const { searchParams } = props;
  const route = useRouter();

  const { isLoggedIn } = useAuth();

  useEffect(() => {
    if (isLoggedIn) {
      route.push("dynamic/Shesha.Recruitment/dashboard");
    }
  }, [isLoggedIn]);

  const formId: FormIdentifier = {
    module: "Shesha.Recruitment",
    name: "landing-page",
  };
  return <DynamicPage {...searchParams} formId={formId} />;
};

export default Home;
